import { render } from "./PosCalculatorModal.vue?vue&type=template&id=1735dda4&scoped=true"
import script from "./PosCalculatorModal.vue?vue&type=script&lang=js"
export * from "./PosCalculatorModal.vue?vue&type=script&lang=js"

import "./PosCalculatorModal.vue?vue&type=style&index=0&id=1735dda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1735dda4"]])

export default __exports__